/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'aufsteigend',
  'fabric.editor.headingLink.copied': 'Kopiert!',
  'fabric.editor.headingLink.copyAnchorLink': 'Link zur Überschrift kopieren',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopieren',
  'fabric.editor.headingLink.descSortingLabel': 'absteigend',
  'fabric.editor.headingLink.failedToCopy': 'Kopieren ist fehlgeschlagen',
  'fabric.editor.headingLink.noneSortingLabel': 'Keine',
  'fabric.editor.inlineComment.marker.end': 'Ende des Inline-Kommentars',
  'fabric.editor.inlineComment.marker.start': 'Beginn des Inline-Kommentars',
};
